import {
  DesignTokenSizeEnum,
  Text,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { useTribalContext } from '@/context/tribal';
import {
  getActiveConfiguration,
  isStockCar,
} from '@/modules/utils/storeUtils';
import useGlobalStore, {
  GlobalStoreStateConfiguration,
} from '@/stores/globalStore';
import Box from '../Box/Box';
import PillModal from '../PillModal/PillModal';
import {
  StyledColumn1,
  StyledColumn2,
  StyledColumnWrapper,
  StyledFooterBackToTopWrapper,
  StyledWrapper,
} from './Footer.styles';
import FooterCTABackToTop from './FooterCTABackToTop/FooterCTABackToTop';
import FooterRetailer from './FooterRetailer/FooterRetailer';
import FooterSelections from './FooterSelections/FooterSelections';
import FooterSocialMedia from './FooterSocialMedia';
import FooterWelcome from './FooterWelcome/FooterWelcome';
import {
  performVWBasicLayerClose,
  performVWBasicLayerLoad,
} from '@/analytics/events';
import { SectionNames } from '@/analytics/sectionNames';

interface FooterProps {
  showComparisonView?: boolean;
}

const Footer = ({ showComparisonView }: FooterProps) => {
  const { contentManager, analyticsManager, analyticsBuilder } =
    useTribalContext();
  const { app } = useGlobalStore();

  const activeConfiguration: GlobalStoreStateConfiguration | undefined =
    getActiveConfiguration(app);

  if (!activeConfiguration) return null;

  const showStockCta = isStockCar(activeConfiguration);

  const analyticsCommonFields = {
    sectionName: SectionNames.FOOTER,
    configuration: activeConfiguration,
    retailers: app.retailers,
    analyticsManager,
    analyticsBuilder,
  };

  return (
    <Text appearance={TokenTextAppearance.copy100}>
      <StyledWrapper>
        <StyledFooterBackToTopWrapper>
          <FooterCTABackToTop />
        </StyledFooterBackToTopWrapper>
        <StyledColumnWrapper>
          <StyledColumn1>
            <FooterWelcome />
            <Box mb={DesignTokenSizeEnum.static150}>
              {showStockCta && !showComparisonView && (
                <Box mb={DesignTokenSizeEnum.static100}>
                  <PillModal
                    modalProps={{
                      description: contentManager.get('stock-badge-info'),
                      onOpen: () =>
                        performVWBasicLayerLoad(analyticsCommonFields),
                      onClose: () =>
                        performVWBasicLayerClose(analyticsCommonFields),
                    }}
                  >
                    {contentManager.get('stock-badge-label')}
                  </PillModal>
                </Box>
              )}
            </Box>

            <FooterSelections
              activeConfiguration={activeConfiguration}
              showComparisonView={showComparisonView}
            />
          </StyledColumn1>
          <StyledColumn2>
            <FooterRetailer
              retailerContact={app.retailerContact}
              retailerData={app.retailers}
            />
            <FooterSocialMedia />
          </StyledColumn2>
        </StyledColumnWrapper>
      </StyledWrapper>
    </Text>
  );
};

export default Footer;
